/* ============
 * Transfer Transformer
 * ============
 */

import Transformer from './transformer';

export default class TransferProductTransformer extends Transformer {

  static fetch(transfer) {
    return {
      id: transfer.id,
      batchId: transfer.batch_id,
      qty: transfer.qty,
      productId: transfer.product_id,
      productName: transfer.product_name,
      productSku: transfer.product_sku,
      transferId: transfer.transfer_id,
      batch: transfer.batch,
      transfer: transfer.transfer,
    };
  }

  static send(transfer) {
    const productId = typeof transfer.productId === 'object' ? transfer.productId.id : transfer.productId;
    return {
      batch_id: transfer.batchId,
      qty: transfer.qty,
      id: productId,
      name: transfer.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/transferProduct.js